module.exports = __webpack_public_path__ + "img/NIH-ASA_Logo.eb8558fa.png";